export default __webpack_public_path__ + "static/media/8.4f8c0570.png";